"use client";

import createIconSet from './createIconSet';
import font from './vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';
import glyphMap from './vendor/react-native-vector-icons/glyphmaps/MaterialCommunityIcons.json';

export default createIconSet(glyphMap, 'material-community', font);
